export default __webpack_public_path__ + "static/rasgullapink-c1661b835e16959d14b604f19516dd20.png";